import { CuttingPanelBaseSlot, GrooveTypeEnum } from './cutting-panel-base-slot.model';
import { PlateTypeEnum } from './cutting-panel-outline.model';

export class CuttingPanelSlot implements CuttingPanelBaseSlot {
  id: number;
  name: string;
  designation: string;
  h: number;
  g: number;
  dx: number;
  fi: number;
  b: number;
  r: number;
  type: GrooveTypeEnum;
  custom: boolean;
  plate: PlateTypeEnum;
  isNameError?: boolean;
}
